import { ComponentProps } from 'react';
import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb';

const contentPanelBreadcrumbsBreadcrumbStyle1 = css`
  padding-top: ${theme.spacing(1)};
  padding-bottom: ${theme.spacing(1)};
  padding-left: 4em;
  border-bottom: 1px solid #ddd;
`;

type Props = {
  links: ComponentProps<typeof Breadcrumb.Path>[];
};

export const ContentPanelBreadcrumbs = ({ links }: Props) => {
  return (
    <Breadcrumb className={contentPanelBreadcrumbsBreadcrumbStyle1}>
      {links.map((crumb, i) => (
        <Breadcrumb.Path key={i} {...crumb} />
      ))}
    </Breadcrumb>
  );
};
